import { render, staticRenderFns } from "./CheckRoosterTable.vue?vue&type=template&id=08417f9b&scoped=true&"
import script from "./CheckRoosterTable.vue?vue&type=script&lang=js&"
export * from "./CheckRoosterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08417f9b",
  null
  
)

export default component.exports